/* eslint no-underscore-dangle: 0 */
import { merge, get } from '../../../utils';
import { actionTypeSelectors, defaultSelector } from './map';
import { getActionMeta } from './meta';
import { mksWhitelist, allUserActions, appContainerId, customEventName } from './constants';

// A log of all actions fired.
let actions = [];

const logLimit = 5;
const logAction = (detail) => {
  // limit the size of the logged actions.
  actions = [...actions.slice(0, logLimit - 1), detail];
};

// get the action type selector
const getActionSelector = type => actionTypeSelectors.find(as => as.type === type)

// check to see if we should handle the current action.
const shouldHandleAction = (action) => {
  // If we are passing a data attribute that suppresses tracking
  // always respect this.
  if (action.suppressTagging === true) {
    return false;
  }
  // Next check if the action type has been white listed,
  // lets us tag non USER_ action types.
  // even if we have a whitelisted action, we still need to provide a selector
  if (mksWhitelist.includes(action.type)) {
    return true;
  }
  // Ensure that the action type starts with the correct
  // prefix for user actions 'USER_'
  if (allUserActions.includes(action.type)) {
    return true;
  }
  return false;
}

const fireDtmCustomEvent = (action, state, actionMeta) => {
  const reduxAction = new CustomEvent(customEventName, {
    detail: {
      actionMeta,
      action,
      state,
    }
  })
  const rootElement = document.getElementById(appContainerId);

  // always capture the tag so DTM can get it later if it needs to.
  logAction({
    actionMeta,
    action,
    state
  });

  // No DTM, no point continuing.
  // Might want to find a way to que this up.
  if (!window || !window._satellite || !window.dtmTrackingDataLayer) {
    // eslint-disable-next-line
    console.warn('Tried to log an event before satellite was ready.', action.type);
    return;
  }

  rootElement.dispatchEvent(reduxAction);
}

const getDispatchedActionsSelector = state => get(state, 'user.dispatchedActions');
// handle action for dtm.
const handleActions = (action, prevState, nextState) => {
  if (!shouldHandleAction(action)) {
    return;
  }

  const actionHandler = getActionSelector(action.type);
  if (!actionHandler) {
    return;
  }

  const pageLayer = actionHandler ? actionHandler.selector(nextState) : defaultSelector(nextState);
  const actionMeta = getActionMeta(action);
  if (!actionMeta.fireOnce || !getDispatchedActionsSelector(nextState).includes(action.type)) {
    fireDtmCustomEvent(action, pageLayer, actionMeta);
  }
}

// This is the export that is setup in the redux store as a proper
// redux middleware. Essentially it just reads actions if
// it matches something that analytics cares about it passes it on.
export const analytics = store => next => (action) => {
  const prevState = merge({}, store.getState());
  const result = next(action);
  const nextState = merge({}, store.getState());
  handleActions(action, prevState, nextState);
  return result;
};

export const createMKSUtils = (store) => {
  /**
   * This will return an array of redux actions since the last time the method was called.
   * This array has a maxsize to avoid memory issues.
   */
  window.DTMdumpReduxActions = () => {
    const dump = [...actions];
    actions = [];
    return dump;
  };
  /**
   * Get the full redux state at any point in time.
   */
  /* eslint-disable */
  window.DTMgetFullReduxState = () => {
    return store.getState();
  };
  /**
   * Get the more helpful DTM mapped state at any point intime.
   */
  window.DTMgetMappedState = () => {
    return defaultSelector(store.getState());
  };
};



/** WEBPACK FOOTER **
 ** ./src/redux/middleware/analytics/index.js
 **/